import { isAnalyticsAllowed } from "components/cookieConsent/cookieConsent";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-RZ6L23C0Y9";

let loadScheduledOrDone = false;

/**
 * Load gtag.js only when analytics cookies are allowed (keelzo_cookie_consent).
 * Call on app boot and after the user saves cookie preferences.
 */
export function loadGtagIfConsented() {
  if (typeof window === "undefined" || loadScheduledOrDone) return;
  if (!isAnalyticsAllowed()) return;

  loadScheduledOrDone = true;

  const exec = () => {
    if (!isAnalyticsAllowed()) {
      loadScheduledOrDone = false;
      return;
    }

    const s = document.createElement("script");
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    s.async = true;
    document.head.appendChild(s);
    s.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", GA_ID);
    };
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(exec, { timeout: 3000 });
  } else if (document.readyState === "complete") {
    setTimeout(exec, 0);
  } else {
    window.addEventListener("load", () => setTimeout(exec, 0));
  }
}
